import cn from 'classnames/bind';
import Image from "next/legacy/image";
import Link from 'next/link';
import PropTypes from 'prop-types';
import { Card, Label, Text } from 'ui';
import { getAuthorHref, getCategoryHref } from 'utils/links';

import s from './BlogCard.module.scss';

const cx = cn.bind(s);

const removeSearchParams = (url) => {
  // Create a URL object from the input URL
  const urlObj = new URL(url);

  // Return the URL without search parameters
  return urlObj.origin + urlObj.pathname;
}


const BlogCard = ({
  children,
  title,
  text,
  author,
  poster,
  posterMeta,
  isExtended = false,
  external = false,
  date,
  label = '',
  className,
  href = '/',
  blogTopic,
  ...attrs
}) => {
  const linkProps = external ? {
    target: "_blank",
    rel: "noopener noreferrer"
  } : {}
  return (
    <Card className={cx(className, 'card')} {...attrs}>
      <Link href={href} className={cx('image', { isExtended })} {...linkProps}>
        <Image src={removeSearchParams(poster)} alt={posterMeta?.altText || title} title={posterMeta?.title} layout="fill" objectFit="cover" />
      </Link>
      <div className={cx('content')}>
        <div className={cx('row')}>
          {date && <div className={cx('date')}>{date}</div>}
          {label && <Label>{label}</Label>}
        </div>
        <Text as="h4" className={cx('title')}>
          <Link href={href} className={cx('titleLink')} {...linkProps}>
            {title}
          </Link>
        </Text>
        <div className={cx('footerWrapper')}>
          <p className={cx('text', 'lg:tp-text tp-text-small')}>{text}</p>
          <div className={cx('row', 'footer')}>
            <div className="flex gap-3 items-end justify-between w-full">
              {author && (
                <Link href={getAuthorHref(author.slug)} className="min-w-max">
                  <div className="flex gap-2 items-center">
                    <Image
                      src={author.image}
                      alt={`${author.name} photo`}
                      width={36}
                      height={36}
                      className="rounded-full max-w-full h-auto"
                    />
                    <div>
                      <p className="text-[14px] leading-[20px] font-semibold text-black opacity-60">{author.name}</p>
                      <p className="tp-hint text-gray4">{author.role}</p>
                    </div>
                  </div>
                </Link>
              )}
              {blogTopic && <Link className="ml-auto text-ellipsis pb-1 overflow-hidden whitespace-nowrap text-mint" href={getCategoryHref(blogTopic.slug.current)}>{blogTopic.title}</Link>}
            </div>
          </div>
        </div>
      </div>
    </Card>
  )};

BlogCard.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  author: PropTypes.shape({
    name: PropTypes.string,
    role: PropTypes.string,
    slug: PropTypes.string,
    image: PropTypes.string,
  }),
  isExtended: PropTypes.bool,
  category: PropTypes.shape({
    title: PropTypes.string,
    slug: PropTypes.string,
  }),
  date: PropTypes.string,
  label: PropTypes.string,
  poster: PropTypes.string,
  href: PropTypes.string,
};

export default BlogCard;
